export default __webpack_public_path__ + "static/media/IMG_0008.c8d6967c.JPG";